import { ITagStatus } from '@tecalisdev/infinity';
import {
	BOOLEAN_STATUS,
	IOperationDocument,
	IOperationDocumentsDetail,
} from '../../processes/models/processes.models';
import { MenuItemAction } from '../../shared/models/master.models';
import { IOperationActivity } from '../models/operations.models';

export interface DocumentsActivityLogContext {
	startAt?: string | null;
	endAt?: string | null;
	logsUrl?: string | null;
}

export interface DocumentsActivityLogDeps {
	translate: (key: string, params?: Record<string, unknown>) => string;
	hasTranslation: (key: string) => boolean;
	getTagStatus: (state: string) => ITagStatus;
}

/** Filas de actividad DOCUMENTS compartidas process↔ops (sin section / never-started). */
export function appendDocumentsActivityLogs(
	activity: IOperationActivity[],
	docs: IOperationDocumentsDetail,
	context: DocumentsActivityLogContext,
	deps: DocumentsActivityLogDeps,
): void {
	const startAt = context.startAt ?? docs.start_at;
	if (startAt) {
		activity.push({
			date: startAt,
			description: [deps.translate('PROCESSES.DETAIL.INIT_OPERATION')],
			...(context.logsUrl ? { showLogs: true } : {}),
		});
	}

	docs.document?.forEach((doc: IOperationDocument) => {
		const typeKey = 'DOCS.' + (doc.type?.toUpperCase() ?? '');
		activity.push({
			title: deps.hasTranslation(typeKey) ? deps.translate(typeKey) : '',
			icon: doc.mode === 'manual' ? 'icon-file' : 'icon-connection',
			status: doc.state as unknown as BOOLEAN_STATUS,
		});
	});

	const endAt = context.endAt ?? docs.end_at;
	if (endAt) {
		activity.push({
			description: [deps.translate('PROCESSES.DETAIL.FINISH_SCAN')],
			tag: {
				label: deps.translate(`MASTER.STATUS.${docs.state?.toUpperCase() ?? ''}`),
				status: deps.getTagStatus(docs.state ?? ''),
			},
			date: endAt,
			link: {
				label: deps.translate('GENERAL.SHOW_RESPONSE'),
				action: MenuItemAction.SHOW_JSON,
				info: { title: deps.translate('PROCESSES.DETAIL.DOCUMENTS'), data: docs },
			},
		});
	}
}
